// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6447":"b3f8c31d","6778":"7cdb3cb6"}[chunkId] + ".chunk.css";
};